module.exports = __webpack_public_path__ + "cd7b9848c4f62e7e443f699e209e9b77.png";